import { render, staticRenderFns } from "./ProviderReviews.vue?vue&type=template&id=350ece94&"
import script from "./ProviderReviews.vue?vue&type=script&lang=js&"
export * from "./ProviderReviews.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports